/**
 * Skyrise brand assets — single import point for logos, patterns, etc.
 * Drop new files into src/assets/brand/{logos,patterns,illustrations}/
 */

import logoWhiteMaster from './logos/skyrise-logo-white.png';
import logoMarkWhite from './logos/skyrise-mark-white.png';
import logoBlackMaster from './logos/Skyrise_New_Master_logo_Bk_RGB.png';
import dotGridA from './patterns/Skyrise-Dots-Grid-1920x1080px-A.png';

/** Full wordmark — white on dark backgrounds (sidebar, forecasting headers, login panel).
 *  Sized for its largest on-screen use (110px) at 3x; the 4000px master in this
 *  folder stays as the print/source original and is not shipped to the browser. */
export const LOGO_WHITE = logoWhiteMaster;

/** Mark only — the Skyrise swirl, for the collapsed sidebar rail. */
export const LOGO_MARK_WHITE = logoMarkWhite;

/** Full wordmark — black/Ink on light backgrounds (login form panel). */
export const LOGO_INK = logoBlackMaster;

/** Dot-matrix grid for dark UI shells (sidebar, dashboards). Variant A–L available in patterns/. */
export const PATTERN_DOT_GRID = dotGridA;

export { logoWhiteMaster, logoMarkWhite, logoBlackMaster, dotGridA };
